import { taskSelection } from '../helpers';
import { dependencies } from '../models';
import { useFieldArray, Controller } from 'react-hook-form';
import { useIntl } from 'react-intl';

export const LinkedTaskField = (props: any): JSX.Element => {
  const intl = useIntl();
  const { fields, append, remove } = useFieldArray({
    name: 'linkedTasks',
  });

  return (
    <div>
      <button
        className="button"
        onClick={() =>
          append({
            dependency: 'Select a task dependency', // just push dummy data
            linkedTask: 'select a task to link',
          })
        }
      >
        {'Add linked task'}
      </button>
      {fields.map((item: any, index: number) => (
        <div key={index}>
          <div
            className="linked-task-row"
            style={{
              display: 'flex',
              justifyContent: 'space-between',
              marginBottom: '10px',
            }}
          >
            <div>
              <label>{intl.formatMessage({ id: 'chooseDependency' })}</label>
              <Controller
                name={`linkedTasks[${index}].dependency`}
                render={({ field: { value, onChange } }) =>
                  taskSelection({
                    options: dependencies,
                    intl: intl,
                    input: {
                      value,
                      onChange,
                    },
                    placeholderText: intl.formatMessage({ id: 'search' }),
                    ...props,
                  })
                }
              />
            </div>
            <div>
              <label>{intl.formatMessage({ id: 'chooseTask' })}</label>
              <Controller
                name={`linkedTasks[${index}].linkedTask`}
                render={({ field: { value, onChange } }) =>
                  taskSelection({
                    options: props.tasks,
                    intl: intl,
                    input: {
                      value,
                      onChange,
                    },
                    placeholderText: intl.formatMessage({ id: 'search' }),
                    ...props,
                  })
                }
              />
            </div>
            <div>
              <button className="close add-purchase-item" onClick={() => remove(index)}>
                <i className="icon icon-squared-cross"></i>
              </button>
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};
